export const getFileTypeIcon = (name = "") => {
  const ext = name.split(".").pop()?.toLowerCase() || "";

  const typeMap = {
    doc: "word",
    docx: "word",
    pdf: "pdf",
    jpg: "image",
    jpeg: "image",
    png: "image",
    gif: "image",
    xls: "excel",
    xlsx: "excel",
    ppt: "powerpoint",
    pptx: "powerpoint",
    zip: "zip",
    rar: "zip",
    "7z": "zip",
    pyz: "zip",
    js: "js",
    py: "py",
    ts: "ts",
    jsx: "jsx",
    html: "html",
    css: "css",
    csv: "csv",
    java: "java",
    php: "php",
    txt: "txt",
    // Corrected video formats
    mp4: "video",
    mov: "video",
    avi: "video",
    mkv: "video",
    wmv: "video",
    flv: "video",
    webm: "video",
    mpeg: "video",
    mpg: "video",
    m4v: "video",
    apk: "apk",
    exe: "exe",
    "3gp": "video", // Added quotes for numeric key
  };

  const fileType = typeMap[ext] || "default";
  return `/Images/Icons/${fileType}.png`;
};
